<template>
  <div class="page-header">
    <div class="header-arrows" @click="goBack">
      <a-icon type="left" :style="{fontSize:'25px'}"/>
      <div class="arrows-title">编辑{{ catalogId | productTypeName }}商品</div>
    </div>
    <a-steps class="steps" :current="current" @change="onChange">
      <a-step title="基础信息"/>
      <a-step v-if="catalogId==2" title="预订设置"/>
      <template v-if="catalogId==73||catalogId==74">
        <a-step title="行程信息"/>
        <a-step title="预订设置"/>
        <a-step title="套餐/价格/库存"/>
      </template>
      <a-step v-else :title="stepTitle"/>
      <a-step title="发布并上架"/>
    </a-steps>
    <div class="header-right"></div>
  </div>
</template>

<script>

export default {
  name: 'ProductHeader',
  props: {
    currentTab: {
      type: Number,
      default: 0
    },
    stepTitle: {
      type: String,
      default: '套餐/价格/库存'
    },
    isMType: {
      type: Number | String,
      default: 0
    }
  },
  data() {
    return {
      current: undefined,
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      isBack: this.$route.query.isBack,
      mType: false
    }
  },
  watch: {
    currentTab(val) {
      this.current = val
    },
    isMType(val) {
      this.mType = val
    }
  },
  mounted() {
    this.current = this.currentTab
    this.mType = this.isMType
  },
  methods: {
    goBack() {
      this.getLogUtils().logWithTag('this.isBack', this.isBack)
      if (!this.isBack) {
        this.$router.go(-1)
      }
    },
    onChange(current) {
      this.getLogUtils().logWithTag('==onChange==', current)
      if (this.proId != 0) {
        if (current == 0) {
          this.current = current
          this.toEditor(this.proId, this.catalogId, this.proSource, this.mType)
        } else if (current == 1) {
          this.current = current
          if (this.catalogId == 5) {
            this.onRouterPage(this.proId, this.catalogId, this.proSource, this.mType)
          } else {
            this.onRouterPage(this.proId, this.catalogId, this.proSource)
          }
        } else if (current == 2 || current == 3) {
          if (this.catalogId == 73 || this.catalogId == 74) {
            this.current = current
            this.goRouter(this.current == 2 ? 'PresaleSetting' : 'OptionList')
          } else if (this.catalogId == 2) {
            this.current = current
            this.goRouter('HotelOptionList')
          } else {
            return
          }
        }
      }
    },
    toEditor(proId, catalogId, proSource, mType) {
      let name = ''
      if (catalogId == 1) {
        name = 'TicketsBasicInfo'
      } else if (catalogId == 2) {
        name = 'HotelBasicInfo'
      } else if (catalogId == 3) {
        name = 'VisaBasicInfo'
      } else if (catalogId == 4) {
        name = 'ScenicHotelBasicInfo'
      } else if (catalogId == 5) {
        name = 'DepartmentBasicInfo'
      } else if (catalogId == 8) {
        name = 'PresellBasicInfo'
      } else if (catalogId == 75) {
        name = 'TravelBasicInfo'
      } else {
        name = 'TourBasicInfo'
      }
      if (catalogId == 5) {
        this.$router.push({
          name,
          query: {
            proId: proId,
            catalogId: catalogId,
            proSource: proSource,
            isMType: mType
          }
        })
      } else {
        this.$router.push({
          name,
          query: {
            proId: proId,
            catalogId: catalogId,
            proSource: proSource
          }
        })
      }
    },
    onRouterPage(proId, catalogId, proSource, mType) {
      let name = ''
      if (catalogId == 8) {
        name = 'PresellBookSet'
      } else if (catalogId == 75) {
        name = 'TravelProDes'
      } else if (catalogId == 5) {
        name = 'DepartmentPriceSetting'
      } else if (catalogId == 73 || catalogId == 74) {
        name = 'ItineraryInformation'
      } else if (catalogId == 2) {
        name = 'HotelBookSet'
      } else {
        name = 'OptionList'
      }
      if (catalogId == 5) {
        this.$router.push({
          name,
          query: {
            proId: proId,
            catalogId: catalogId,
            proSource: proSource,
            isMType: mType
          }
        })
      } else {
        this.$router.push({
          name,
          query: {
            proId: proId,
            catalogId: catalogId,
            proSource: proSource
          }
        })
      }
    },
    goRouter(name) {
      this.$router.push({
        name: name,
        query: {
          proId: this.proId,
          catalogId: this.catalogId,
          proSource: this.proSource
        }
      })
    }
  }

}
</script>
<style lang="less" scoped>
.page-header {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  background-color: #FFFFFF;

  .header-arrows {
    display: flex;
    align-items: center;
    width: 256px;
    cursor: pointer;

    .arrows-title {
      font-size: 16px;
      font-weight: 500;
      margin-left: 15px;
    }
  }

  .steps {
    flex: 1;
    cursor: pointer;
  }

  .header-right {
    width: 100px;
    padding-left: 30px;
    box-sizing: border-box;
  }
}
</style>